const CLASSES = {
  default: "brh-hero-collage",
  get main() {
    return `.${CLASSES.default}`;
  },
  get slider() {
    return `.${CLASSES.main}__slider`;
  },
  get image() {
    return `.cmp-image__image`;
  },
  selector: {
    get animateSlider() {
      return `.js-animate-slider`;
    },
  },
};

export default CLASSES;
